import axios from "axios";

// export const BASE_URL = "http://localhost:5002/api"; // Ensure this URL is correct
// export const BASE_URL = "https://grocery-be-production.up.railway.app/api";
export const BASE_URL = "https://grocery-be.vercel.app/api";

const axiosServices = axios.create({ baseURL: BASE_URL });

axiosServices.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem('serviceToken') ||
      localStorage.getItem('authToken') ||
      localStorage.getItem('token') ||
      localStorage.getItem('accessToken');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosServices.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Handle specific errors if the response exists
      if (
        error.response.status === 401 &&
        !window.location.href.includes("/login")
      ) {
        // Redirect to login if necessary
      }
      return Promise.reject(
        (error.response && error.response.data) || "Wrong Services",
      );
    } else {
      // Handle network error
      console.error("Network Error:", error.message);
      return Promise.reject("Network error or server is down");
    }
  },
);

export default axiosServices;
